@if (!hideDipSwitch || !hideContractSwitch) {
  <div
    class="dip-picker-container "
    [ngClass]="{
      'dip-picker-container--contracts': hideDipSwitch && !hideContractSwitch,
      'dip-picker-container--strategy': type === 'new-strategy'
    }"
    >
    @if (!hideDipSwitch && hideContractSwitch) {
      <div class="dip-label" [ngClass]="{ 'dip-label--strategy': type === 'new-strategy' }">
        {{ 'newPortfolio.filters.dip' | translate }}
      </div>
      <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
        @if (type === 'new-strategy') {
          {{ 'global.tooltips.dipNewStrategy' | translate }}
        } @else {
          {{ 'global.tooltips.dipNewPortfolio' | translate }}
        }
      </libero-tooltip-button>
      <div 
        class="dip-switch-container" 
        [ngClass]="{
          'w-100': type === 'new-strategy',
          'dip-switch-container--disabled': efektikaLimitedDip
        }"
        #tooltipHoverableSwitch
      >
        <libero-toggle-switch
          [formName]="switchForm.controls['dip']"
          [disabled]="dipDisabled || efektikaLimitedDip"
        ></libero-toggle-switch>
      </div>
    }
    @if (hideDipSwitch && !hideContractSwitch) {
      <div class="contracts-label">
        {{ 'newPortfolio.filters.contractNumber' | translate }}
      </div>
      <div class="contracts-container">
        <div class="radios-container">
          <label 
            class="radio-container" 
            [ngClass]="{'radio-container--disabled': efektikaLimitedDip && formName.value.frameworkContractNumber !== availableContracts[0].frameworkContractNumber}"
            #tooltipHoverableRadio1
          >
            {{ availableContracts[0].frameworkContractNumber }}
            <input
              [id]="availableContracts[0].frameworkContractNumber"
              type="radio"
              [value]="availableContracts[0].frameworkContractNumber"
              [name]="availableContracts[0].frameworkContractNumber"
              (change)="updateRadioValue(availableContracts[0].frameworkContractId)"
              [checked]="formName.value.frameworkContractNumber === availableContracts[0].frameworkContractNumber"
              [disabled]="efektikaLimitedDip && formName.value.frameworkContractNumber !== availableContracts[0].frameworkContractNumber"
            />
              <span class="checkmark"></span>
            </label>
          <label 
            class="radio-container" 
            [ngClass]="{'radio-container--disabled': efektikaLimitedDip && formName.value.frameworkContractNumber !== availableContracts[1].frameworkContractNumber}"
            #tooltipHoverableRadio2
          >
              {{ availableContracts[1].frameworkContractNumber }}
              <input
                [id]="availableContracts[1].frameworkContractNumber"
                type="radio"
                [value]="availableContracts[1].frameworkContractNumber"
                [name]="availableContracts[1].frameworkContractNumber"
                (change)="updateRadioValue(availableContracts[1].frameworkContractId)"
                [checked]="formName.value.frameworkContractNumber === availableContracts[1].frameworkContractNumber"
                [disabled]="efektikaLimitedDip && formName.value.frameworkContractNumber !== availableContracts[1].frameworkContractNumber"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        }
        @if (displayEfektikaTooltip) {
          <div #tooltipContent style="display: none;">
            <div class="tooltip-content" data-cy="dip-switch-efektika-tooltip">
              <div class="tooltip-text"> {{ 'global.tooltips.efektikaDipLimit' | translate }} </div>
            </div>
          </div>
        }
      </div>
    }
